import React from "react";
import { Star } from "lucide-react";

export default function RatingStars({ value = 0, count, size = "sm", showCount = true, testid = "rating" }) {
  const filled = Math.round(value || 0);
  const px = size === "lg" ? "w-5 h-5" : size === "md" ? "w-4 h-4" : "w-3.5 h-3.5";
  return (
    <span className="inline-flex items-center gap-1.5" data-testid={testid}>
      <span className="flex items-center">
        {[1, 2, 3, 4, 5].map((i) => (
          <Star key={i} className={`${px} ${i <= filled ? "text-primary fill-primary" : "text-muted-foreground/40"}`} />
        ))}
      </span>
      {value ? <span className="text-xs font-semibold text-secondary">{value.toFixed(1)}</span> : <span className="text-xs text-muted-foreground">No ratings yet</span>}
      {showCount && count !== undefined && count > 0 && <span className="text-xs text-muted-foreground">({count})</span>}
    </span>
  );
}
